<template>
  <div>
    <SearchForm
      v-if="show"
      :placeholder="$t('search_drugs_form.placeholder')"
      @search="onSearch"
    >
      <vue-element-loading :active="loading" />
    </SearchForm>

    <b-col cols="12" class="p-0 pt-2 d-flex flex-wrap">
      <span class="text-search d-none d-sm-block">{{ $t('search_drugs_form.search_all_drugs') }}</span>

      <div class="d-none d-sm-block">
        <template v-for="letter in letters">
          <span class="letter" v-bind:key="letter">
            <router-link class="search-letter-link" :to="{ name: 'search', query: { letter: letter }}">{{ letter }}</router-link>
          </span>
        </template>
      </div>
    </b-col>
  </div>
</template>


<script>
import SearchForm from "@/components/SearchForm";

export default {
  name: "search",
  components: {
    SearchForm,
  },
  data() {
    return {
      loading: false,
      form: {
        query: undefined,
      },
      show: true,
      letters: [...Array(26)].map((e, i) => (i + 10).toString(36)),
    };
  },
  mounted: function() {
    if (this.$route.query.query) {
      this.form.query = this.$route.query.query;
    }
  },
  methods: {
    onSearch(query) {
      this.loading = true;
      this.query = query;
      this.$router.push({ name: "search", query: { query: this.query } });
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        search_drugs_form: {
          placeholder: "Neutrogena, vitaminas, antienvejecimiento...",
          search_all_drugs: "Search all medicaments:",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.input-wrapper {
  position: relative;
}

.text-search {
  color: #575757;
  font-size: 12px;
}

#search_button {
  background: #fe5e00;
  display: block;
  position: absolute;
  top: 0px;
  right: 0px;
  border: none;
  color: white;
  text-align: center;
  width: 32px;
  min-width: 32px;
  height: 100%;
  padding: 4px;
}

.search-letter-link {
  color: $corp-color2;
  font-size: 12px;
  text-transform: uppercase;
  padding: 0 3px;

  &:hover {
    color: $corp-color1;
  }
}
</style>
